import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mt-5 mb-2 text-[12px]" }, "Cuenta seleccionada", -1)
const _hoisted_2 = { class: "col-span-4 lg:col-span-1 flex justify-between items-center border rounded px-3 py-2 cursor-pointer" }
const _hoisted_3 = { class: "flex justify-between items-center w-full" }
const _hoisted_4 = { class: "flex flex-col justify-start items-start gap-1" }
const _hoisted_5 = { class: "text-[14px]" }
const _hoisted_6 = { class: "text-[14px]" }
const _hoisted_7 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_8 = {
  key: 1,
  class: "text-[12px]"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mt-5 mb-2 text-[12px]" }, "Ingrese los datos", -1)
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2 bg-gray-200 rounded-md p-4 text-sm" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-semibold" }, "Datos de transferencia"),
  /*#__PURE__*/_createElementVNode("p", null, "RENTAS DHELOS SPA 77.240.362-3"),
  /*#__PURE__*/_createElementVNode("p", null, "CTA CTE 78211245 SANTANDER"),
  /*#__PURE__*/_createElementVNode("p", null, "Mail: contacto@rentasdhelos.com"),
  /*#__PURE__*/_createElementVNode("p", null, "Comentario: compra acciones de xx")
], -1)
const _hoisted_12 = {
  key: 1,
  class: "text-center mt-5"
}
const _hoisted_13 = ["disabled"]

import { computed, ref } from "vue";
import Swal from "sweetalert2";
import {
  MovementService,
  MovementEnum,
  GroupEnum,
  MovementEnumSpanish,
} from "@/services/shareholder_shares/MovementService";

import { shareMovementStore } from "@/stores/movements";
import { shareholderStore } from "@/stores/shareholder";
import { accountStore } from "@/stores/account";


import Modal from "@/components/atoms/Modal.vue";
import TextField from "@/components/atoms/TextField.vue";
import Selector from "@/components/atoms/Selector.vue";

declare type enumType = keyof typeof MovementEnum;
declare type enumGrup = keyof typeof GroupEnum;


export default /*#__PURE__*/_defineComponent({
  __name: 'NewMovementModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;



const visible = computed(() => props.visible);



const shareholderStr = shareholderStore();
const movementsStore = shareMovementStore();

const accountStr = accountStore();
const activeAccount = computed(() => accountStr.activeAccount);


const shareholderId = parseInt(localStorage.getItem("user_id") || "0", 10);

const movementService = new MovementService();
const loading = ref(false);

// Información basica
const date = ref(new Date().toString());
const typeAction = ref<enumType>("");
const group = ref<enumGrup>("");
const amount = ref<number | undefined>(undefined);

const typeActionsSpanish = ref([
  MovementEnumSpanish[0],
  MovementEnumSpanish[1],
]);
const groups = ref([GroupEnum[1]]);
/**
 * Comprueba si el valor ingresado como parámetro es nulo o no definido.
 * @param value Valor a comprobar
 */
function isNullOrEmpty(value?: string | number | null): boolean {
  return !value || value == null || value == "" || value == 0;
}

// Indica si el formulario tiene algun error de dato o valor requerido
const formHasError = computed(() => {
  const requiredFields = [typeAction.value, amount.value];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [typeActionFieldHasError.value, amountFieldHasError.value];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});

const typeActionFieldHasError = computed(() => {
  if (typeAction.value == "") {
    return false;
  }

  return isNullOrEmpty(typeAction.value);
});

const amountFieldHasError = computed(() => {
  if (amount.value == undefined) {
    return false;
  }
  return isNullOrEmpty(amount.value);
});

/**
 * Envia una solicitud al backend para registrar al nuevo accionista
 */
async function registerShareholder() {
  loading.value = true;

  try {
    if (group.value === "GRUPO A") {
      const response = await movementService.registerMovementsA(
        shareholderId,
        date.value,
        typeAction.value,
        group.value,
        amount.value,
        activeAccount.value
      );
      if (response.success == true) {
        loading.value = false;
        emit("update:visible", false);
        movementsStore.query();
        shareholderStr.query(shareholderId);
        group.value = "";
        typeAction.value = "";
        amount.value = undefined;
        Swal.fire(
          "¡Listo!",
          "Solicitud de Movimiento en GRUPO A realizada con éxito",
          "success"
        );
      } else {
        Swal.fire(
          "¡Error!",
          "Usuario no tiene suficientes acciones de ese grupo para solicitar esta venta",
          "error"
        );
      }
    } else if (group.value === "GRUPO B") {
      const response = await movementService.registerMovementsB(
        shareholderId,
        date.value,
        typeAction.value,
        group.value,
        amount.value,
        activeAccount.value
      );
      if (response.success == true) {
        loading.value = false;
        emit("update:visible", false);
        movementsStore.query();
        shareholderStr.query(shareholderId);
        group.value = "";
        typeAction.value = "";
        amount.value = undefined;
        Swal.fire(
          "¡Listo!",
          "Solicitud de Movimiento en GRUPO B realizada con éxito",
          "success"
        );
      } else {
        Swal.fire(
          "¡Error!",
          "Usuario no tiene suficientes acciones de ese grupo para solicitar esta venta",
          "error"
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    title: "Solicitar movimiento",
    class: "",
    visible: _unref(visible),
    "onUpdate:visible": _cache[3] || (_cache[3] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      (_unref(activeAccount) != 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(accountStr)?.accountSelected?.businessName ? _unref(accountStr)?.accountSelected?.businessName : `${_unref(accountStr)?.accountSelected?.firstName} ${_unref(accountStr)?.accountSelected?.lastName}`), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(accountStr)?.accountSelected?.email), 1),
                  (
                  _unref(accountStr)?.accountSelected?.investorNumberA &&
                  _unref(accountStr)?.accountSelected?.investorNumberA > 0
                )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, " ID B: " + _toDisplayString(_unref(accountStr)?.accountSelected?.investorNumberB) + " - ID A: " + _toDisplayString(_unref(accountStr)?.accountSelected?.investorNumberA), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_8, " ID B: " + _toDisplayString(_unref(accountStr)?.accountSelected?.investorNumberB), 1))
                ])
              ])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(Selector, {
                label: "Tipo",
                class: "w-full",
                model: typeAction.value,
                "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((typeAction).value = $event)),
                "has-error": _unref(typeActionFieldHasError),
                "error-message": "Es necesario indicar el Tipo de movimiento",
                items: typeActionsSpanish.value
              }, null, 8, ["model", "has-error", "items"]),
              _createVNode(Selector, {
                label: "Grupo",
                class: "w-full",
                model: group.value,
                "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((group).value = $event)),
                "has-error": _unref(typeActionFieldHasError),
                "error-message": "Es necesario indicar el Grupo de movimiento",
                items: groups.value
              }, null, 8, ["model", "has-error", "items"]),
              _createVNode(TextField, {
                model: amount.value,
                "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((amount).value = $event)),
                "has-error": _unref(amountFieldHasError),
                "error-message": "Es necesario indicar el monto del movimiento",
                type: "number",
                name: "amount",
                label: 'Cantidad de acciones',
                "hide-details": ""
              }, null, 8, ["model", "has-error"]),
              _hoisted_11
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Seleccione una cuenta antes de realizar un movimiento "))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "success btn ml-auto",
        onClick: registerShareholder,
        disabled: _unref(formHasError) || _unref(activeAccount) == 0
      }, " Solicitar ", 8, _hoisted_13)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})